import {injectable} from "tsyringe";
import {transformer} from "../decorators/transformer.decorator";
import {KeywordDTO} from "../domain/dtos/keyword.dto";
import {Keyword} from "../domain/entities/keyword.entity";
import {TransformerInterface} from "./transformerInterface";

@injectable()
@transformer({
    source: Keyword,
    target: `dto`
})
export class KeywordToDtoTransformer implements TransformerInterface<Partial<KeywordDTO>, Keyword> {

    public transform(keyword: Keyword): Promise<Partial<KeywordDTO>> {
        const dto: KeywordDTO | null = keyword.isNew()
            ? {
                uid: keyword.uid,
                key: keyword.key,
                shortcut: keyword.shortcut,
                createdAt: keyword.createdAt.toUTC().toSQL()!,
                color: keyword.color,
                textColor: keyword.textColor,
                sorting: -1,
            }
            : Object.fromEntries(
                keyword.changedValues.map(propertyName => [propertyName, new Map(Object.entries(keyword)).get(`_${propertyName}`)!])
            ) as KeywordDTO;

        return Promise.resolve(dto);
    }

}